import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedbackTitle: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.empty-view.feedback-title',
		defaultMessage: 'Where would you like to import data from?',
		description: 'Title of the feedback collector',
	},
	customTextAreaLabel: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.empty-view.custom-text-area-label',
		defaultMessage: 'Let us know what apps you’d like us to extend support to',
		description: 'The label for text area in the feedback collector',
	},
	requestOtherApp: {
		id: 'project-create-importer-upload-flow.select-source-screen.source-section.empty-view.request-other-app',
		defaultMessage:
			'We couldn’t find what you are looking for. <link>Let us know</link> if there are other apps you are looking to import data from.',
		description: 'The text for default search input',
	},
});
